import { z } from 'zod';

import { UuidSchema } from '../common/id/id';

import { AuditActionSchema } from './audit-action';

/**
 * An audit row as the admin log viewer reads it (P10).
 *
 * `before`/`after` are free-form snapshots of the changed slice, not whole
 * entities — and **never** secret material: integration credentials are masked
 * before they reach here (N21), and a password hash is never in a snapshot at
 * all.
 */
export const AuditLogSchema = z.object({
  id: UuidSchema,
  actorUserId: UuidSchema.nullable(),
  action: AuditActionSchema,
  entityType: z.string(),
  entityId: z.string().nullable(),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.iso.datetime(),
});

export type AuditLog = z.infer<typeof AuditLogSchema>;
